<!-- 
<div style="padding-top:200px;">
  <div nz-row nzJustify="space-around" nzAlign="middle">
   <div nz-col nzSpan="6">
    <div  class="height-150">
    
    <form nz-form [formGroup]="signInFormGroup" class="login-form" (ngSubmit)="onSignInClicked()">
      <nz-form-item>
        <nz-form-control nzErrorTip="Please input your username!">
          <nz-input-group nzPrefixIcon="user">
            <input type="text" nz-input formControlName="username" placeholder="Username" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control nzErrorTip="Please input your Password!">
          <nz-input-group nzPrefixIcon="lock">
            <input type="password" nz-input formControlName="password" placeholder="Password" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
       <div nz-row class="login-form-margin">
        <div nz-col [nzSpan]="12">
          <label nz-checkbox formControlName="remember">
            <span>Remember me</span>
          </label>
        </div>
        <div nz-col [nzSpan]="12">
          <a class="login-form-forgot">Forgot password</a>
        </div>
      </div>  
      <button nz-button class="login-form-button login-form-margin" [nzType]="'primary'">Log in</button>
      
    </form>
</div>
   </div>
 
</div>

</div> -->

<div class="login-container">
  <div nz-row nzJustify="center" nzAlign="middle" class="login-row">
    <div nz-col nzSpan="8">
      <div class="login-card">
        <form nz-form [formGroup]="signInFormGroup" class="login-form" (ngSubmit)="onSignInClicked()">
          <h2 class="login-title">Sign In</h2>

          <nz-form-item>
            <nz-form-control nzErrorTip="Please input your username!">
              <nz-input-group nzPrefixIcon="user">
                <input type="text" nz-input formControlName="username" placeholder="Username" />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-control nzErrorTip="Please input your password!">
              <nz-input-group nzPrefixIcon="lock">
                <input type="password" nz-input formControlName="password" placeholder="Password" />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>


          <button nz-button [nzType]="'primary'" class="login-button" >
            Log in
          </button>
          <!-- <div *ngIf="errorMessage" class="error-text">
            {{ errorMessage }}
          </div> -->
        </form>
      </div>
    </div>
  </div>
</div>
